var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 8.00015H14.6673M14.6673 8.00015L12.4453 5.33348M14.6673 8.00015L12.4453 10.6668M9.33398 4.66681V3.44948C9.33398 3.26506 9.29571 3.08265 9.22161 2.91378C9.1475 2.7449 9.03917 2.59324 8.90346 2.46837C8.76775 2.3435 8.60761 2.24814 8.43317 2.18831C8.25872 2.12849 8.07377 2.10551 7.88998 2.12081L2.55665 2.56481C2.22335 2.59257 1.91266 2.74458 1.68618 2.99069C1.45971 3.23679 1.334 3.55903 1.33398 3.89348V12.1068C1.334 12.4413 1.45971 12.7635 1.68618 13.0096C1.91266 13.2557 2.22335 13.4077 2.55665 13.4355L7.88998 13.8801C8.07382 13.8955 8.25884 13.8725 8.43333 13.8126C8.60782 13.7527 8.76799 13.6573 8.90371 13.5324C9.03943 13.4074 9.14774 13.2557 9.22181 13.0867C9.29587 12.9178 9.33407 12.7353 9.33398 12.5508V11.3335",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.b852d7dd3aeff249031fa223ba9e8341.svg";
export { ForwardRef as ReactComponent };